import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CustomTableHeader from '../../../core/components/ui/custom-table-header.component'

export default function CustomTable({headers, children}) {
  return (
    // <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
    <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow sx={{p: 0}}>
            {headers.map((row) => (
                <CustomTableHeader key={row.label}>{row.label}</CustomTableHeader>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
         {children}
        </TableBody>
      </Table>
    </TableContainer>
    // </Paper>
  );
}
